export type KeyValue<T> = { [key: string | number]: T }

export const sleep = (milliseconds: number) => new Promise(resolve => setTimeout(resolve, milliseconds))

export const parseBool = (input: string | undefined): boolean => {
    if (input == undefined)
        return false

    const lc = `${input}`.toLowerCase()
    return lc == 'true' || lc == '1' || lc == 'yes' || lc == 'ja'
}
